







































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import BusinessHoursDto from '@/models/BusinessHours/BusinessHoursDto'
import BusinessHoursEdit from '@/components/BusinessHours/BusinessHoursEdit.vue';
import BusinessHoursCreate from '@/components/BusinessHours/BusinessHoursCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';


@Component({
  name: 'BusinessHours',
  components: { BusinessHoursEdit, BusinessHoursCreate }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentBusinessHours(null);
    }

    async updateCurrentBusinessHours(businessHours: BusinessHoursDto) {
        AgencySettingsModule.updateCurrentBusinessHours(businessHours);
    }

    get currentBusinessHours() {
        return AgencySettingsModule.currentBusinessHours;
    }

    get loading() {
        return AgencySettingsModule.loadingBusinessHours;
    }

    get businessHours() {
        return AgencySettingsModule.businessHours;
    }

    async deleteBusinessHours(businessHours: BusinessHoursDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the business hours ' + businessHours.name + '?', options);
        // if (result) {
        //     const request = new UpdateAgencyUserStatusRequest();
        //     request.updatedAt = user.updatedAt;
        //     request.status = AgencyUserStatusEnum.Deleted;
        //     await AgencySettingsModule.deleteAgencyUser(request);
        // }
  }
}
